import { render, staticRenderFns } from "./studentLedger.vue?vue&type=template&id=d9fc248e&scoped=true"
import script from "./studentLedger.vue?vue&type=script&lang=js"
export * from "./studentLedger.vue?vue&type=script&lang=js"
import style0 from "./studentLedger.vue?vue&type=style&index=0&id=d9fc248e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fc248e",
  null
  
)

export default component.exports